var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10896_11372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 6.51917L6.89929 1.69718C7.54661 1.21292 8.45306 1.21292 9.10038 1.69718L15.3332 6.51917M2.62206 5.00626V12.9431C2.62206 13.8954 3.42463 14.6673 4.41465 14.6673H5.31095H10.6887H11.585C12.575 14.6673 13.3776 13.8954 13.3776 12.9431V5.00626M6.20724 14.6673V9.49477C6.20724 9.01865 6.60853 8.63268 7.10354 8.63268H8.89613C9.39114 8.63268 9.79243 9.01865 9.79243 9.49477V14.6673",
    stroke: "#000536",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10896_11372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.026072b8b1a6782934e0500b7d967476.svg";
export { ForwardRef as ReactComponent };